import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const AdminRoute = ({ children }) => {
  const userInfo = useSelector(state => state.userState.userInfo)
  const navigate = useNavigate()

  useEffect(() => {
    if (userInfo.role !== 'admin' && userInfo.role !== 'superadmin') {
      navigate('/profile')
    }
  }, [userInfo])

  return (
    <>{children}</>
  )
}

export default AdminRoute